import Phaser from "phaser"
import { cGame } from "../cGame";
import { parseAssetName } from "../cGameObjects/cSprite";

import { cScene } from "../cScene";
import { ScreenItem } from "../dataTypes";
import { ModuleCollection,Base } from "./../cGameObjects/modules";

export class Sticker extends Phaser.GameObjects.Sprite {

  public modules: ModuleCollection;
  private _data: ScreenItem
  public events!: Phaser.Events.EventEmitter

  private stickerName: string = "";

  constructor(sc:cScene, data: ScreenItem){
    super(sc,0,0, parseAssetName(data.asset,'asset') || '', parseAssetName(data.asset,'frame'));

    this._data = data;
    this.modules = Base.initModules(this,data)
    this.stickerName = parseAssetName(data.asset,'frame').replace('button_','sticker_')

    this.events = new Phaser.Events.EventEmitter()  

    if ( cGame.current.state.get(this.stickerName,0) === 1){
      this.visible = false;
    }else{
      this.setInteractive({ useHandCursor: true });  

    }
    


    this.on('pointerup',()=>{      
      cGame.current.state.set(this.stickerName,1);
      this.visible = false;
      this.events.emit('click', this._data)    
    });    

  }

}